import { ROUTES } from 'utils/constants';
import { useToggle } from 'utils/hooks/useToggle';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { getVariant } from 'utils/experiments/useExperiment';
import { KEYS } from './constants';
import { useGetParams } from './useGetParams';
import { handleTrackEvent } from './handleTrackEvent';

// The ✕ opens the exit modal, which is the single decision point: accept the free
// assistant week, or close and stay on the paywall. There is no silent second-tap
// exit — once the discount offer was removed, a "second ✕ leaves directly" shortcut
// only confused users (the first tap showed the modal, the second jumped away).
export const usePaywallExit = ({ screen }) => {
  const { push, entry } = useGetParams();
  const [isExitModalOpen, toggleExitModal] = useToggle();
  const [, setFlow] = useLocalStorage(KEYS.FLOW);

  const trackProps = () => ({
    screen,
    entry_point: entry || 'link',
    paywall_variant: getVariant('paywall'),
  });

  const handleGoBack = () => {
    handleTrackEvent('Exit modal viewed', trackProps());
    toggleExitModal();
  };

  const handleAcceptFreeTier = async () => {
    handleTrackEvent('Exit modal accepted', trackProps());
    await setFlow(null);
    push(ROUTES.EVIE_ASSISTANT);
  };

  const handleDismissModal = () => toggleExitModal();

  return { isExitModalOpen, handleGoBack, handleAcceptFreeTier, handleDismissModal };
};

// Shared by every no-card exit point so 'Paywall skipped' carries one schema; exitSource is
// the only thing that tells them apart on the funnel.
export const usePaywallSkip = (exitSource) => {
  const { push, entry } = useGetParams();
  const [path] = useLocalStorage(KEYS.PATH);

  return () => {
    handleTrackEvent('Paywall skipped', {
      entry_point: entry || 'link',
      path,
      paywall_variant: getVariant('paywall'),
      exit_source: exitSource,
    });
    push(ROUTES.EVIE_ASSISTANT);
  };
};
